import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccordionComponent } from '../../../../../shared/components/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../shared/components/accordion/accordion-item.component';

@Component({
  selector: 'app-product-specifications',
  standalone: true,
  imports: [CommonModule, AccordionComponent, AccordionItemComponent],
  templateUrl: './product-specifications.component.html',
})
export class ProductSpecificationsComponent {
  @Input({ required: true }) specifications!: Map<string, string[]>;
}
